import { Box, Collapse, Stack } from "@chakra-ui/react";
import { usePlayerContext } from "../../providers/PlayerProvider.tsx";
import PlayerBanner from "../PlayerOverlay/PlayerBanner";
import { usePageLoadMetrics } from "../../hooks/GA";
import ReactHlsPlayer from "../../hooks/Player/index.js";
import usePlayerData from "../../hooks/usePlayerData";
import { ControlsOverlay } from "../PlayerOverlay/ControlOverlay";
import { getCookieConsentValue } from "react-cookie-consent";
import { useEffect } from "react";
import {
  selectStreamInfo,
} from "../../redux/slices/playerSlice";
import {useSelector} from "react-redux";
import * as playerState from "../../redux/slices/playerSlice";
import * as adState from "../../redux/slices/adsSlice.js";
import { appendTCFToStreamUrl } from "../../hooks/Ads/Adswizz/initAdwizz";

const AtunwaPlayerComponent = ({ streamUrl }: { streamUrl: string }) => {
  const streamInfo = useSelector(selectStreamInfo);
  const isPlaying = useSelector(playerState.selectPlaying);
  const adIsPlaying = useSelector(adState.selectPlaying);
  const prerollPlayed = useSelector(adState.selectPrerollPlayed);
  const { uiContainerRef, audio, bannerH, width, height } = usePlayerContext();
  usePageLoadMetrics();
  usePlayerData();

  // console.log({streamInfo})
  return (
    <Stack
      bg="secondary.dark"
      p={1}
      ref={uiContainerRef}
      width={`${width}px`}
      height={`${height}px`}
      maxWidth="100%"
      maxHeight="100%"
    >
      <Collapse
        startingHeight={bannerH}
        in={typeof getCookieConsentValue() === "string"}
      >
        <PlayerBanner />
      </Collapse>

      <Box h={0} hidden={adIsPlaying || !streamInfo.isVideo}>
        <ReactHlsPlayer
          src={streamUrl}
          autoPlay={false}
          controls={true}
          width="100%"
          height="auto"
          playerRef={audio}
        />
      </Box>
      <ControlsOverlay />
    </Stack>
  );
};

export default AtunwaPlayerComponent;
